import { render, staticRenderFns } from "./settlments.vue?vue&type=template&id=a4c22778"
import script from "./settlments.vue?vue&type=script&lang=js"
export * from "./settlments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports